import { useMutation, useQueryClient } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useRemoveFiles = ({ caseId }: { caseId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (fileIds: string[]) => {
      const data = {
        fileIds: fileIds,
        caseId,
      };
      const fetchConfig = getFetchConfig({ method: FetchMethod.DELETE, data });

      await fetch(`${APIBaseChronos}/api/files`, fetchConfig);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries([QueryEntity.Files, { caseId }]);
        queryClient.invalidateQueries([QueryEntity.UploadPagesEstimate, caseId]);
      },
    },
  );
};
